import * as React from 'react';
import {
  NewbuildingBrokerContext,
  NewbuildingBrokerModalWindow,
  EButtonType,
  IBrokerData,
} from '@cian/frontend-newbuilding-broker-component';
import { useSelector } from 'react-redux';
import { BrokerButton } from '../../components/BrokerButton';
import { getIsBrokerAvailable, getNewbuildingId, getRegionId } from '../../selectors/newbuilding';
import { useBrokerConfig } from './hooks/useBrokerConfig';
import { useApplicationContext } from '../../utils/applicationContext';
import { getIsSelfEmployed } from '../../selectors/user';
import {
  trackSellApartmentClick,
  trackNextOrGoButtonClick,
  trackRewardInstructionButtonClick,
  trackRewardInstructionLinkClick,
  trackErrorModalOpen,
  trackRetryClick,
} from './tracking';

export function BrokerButtonContainer() {
  const isBrokerAvailable = useSelector(getIsBrokerAvailable);
  const newbuildingId = useSelector(getNewbuildingId);
  const newbuildingRegionId = useSelector(getRegionId);
  const isSelfEmployed = useSelector(getIsSelfEmployed);

  const { enabled, personalDataAgreement, landingUrl } = useBrokerConfig();

  const { httpApi, logger } = useApplicationContext();
  const brokerContextValue = React.useMemo(() => ({ httpApi, logger }), [httpApi, logger]);

  const handleBrokerLinkFetched = (buttonType: EButtonType, result: IBrokerData | null) => {
    if (result) {
      trackNextOrGoButtonClick(buttonType, result.brokerName);
    }
  };

  if (!enabled || !isBrokerAvailable) {
    return null;
  }

  return (
    <NewbuildingBrokerContext.Provider value={brokerContextValue}>
      <NewbuildingBrokerModalWindow
        renderModalOpener={BrokerButton}
        newbuildingId={newbuildingId}
        newbuildingRegionId={newbuildingRegionId}
        houseId={null}
        isSelfEmployed={isSelfEmployed}
        personalDataAgreementLink={personalDataAgreement}
        landingUrl={landingUrl}
        onModalOpenerClick={trackSellApartmentClick}
        onBrokerLinkFetched={handleBrokerLinkFetched}
        onRewardInstructionButtonClick={trackRewardInstructionButtonClick}
        onRewardInstructionLinkClick={trackRewardInstructionLinkClick}
        onErrorModalOpen={trackErrorModalOpen}
        onRetryButtonClick={trackRetryClick}
      />
    </NewbuildingBrokerContext.Provider>
  );
}
